<div class="app-modal app-modal-simple new-version-popup">
  <div class="app-modal-content">
    <div class="app-form-panel app-form-panel-simple">
      <div class="app-form-panel-content">
        <div class="error-content" [class.h100]="message?.length >= 500">
          <div>
            <i
              class="icon-cancel-circled-alt text-danger"
              style="font-size: 60px"
              *ngIf="!isWarning"></i>
            <i
              class="icon-attention-alt text-warning"
              style="font-size: 60px"
              *ngIf="isWarning"></i>
          </div>
          <div class="interface">
            <div class="interface-header fw500 mb20" *ngIf="code && !isWarning">
              {{ 'error.errorCode' | translate }}: {{ code }}
            </div>
            <div class="interface-content">
              <dx-scroll-view
                showScrollbar="always"
                class="error-dialog-limit"
                *ngIf="message?.length >= 500">
                <div [innerHTML]="message"></div>
              </dx-scroll-view>
              <div class="flex-row h100" [innerHTML]="message" *ngIf="message?.length < 500"></div>
            </div>
            <div class="interface-footer" *ngIf="showCopy">
              <div class="mtb20">
                {{ 'error.copyErrorCodeInstructions' | translate }}
              </div>
              <div>
                <a
                  href="javascript:void(0)"
                  class="vam simple-btn simple-btn-md simple-btn-icon"
                  style="text-transform: capitalize"
                  (click)="onCopyClick()"
                  title="{{ 'error.copyErrorCode' | translate }}">
                  <i class="icon-duplicate mr10"></i>
                  {{ 'error.copyErrorCode' | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <a
      #okFocus
      href="javascript:void(0)"
      (click)="onCloseClick()"
      class="simple-btn simple-btn-md simple-btn-rounded simple-btn-primary bigger-side-pads">
      {{ 'actions.ok' | translate }}
    </a>
  </div>
</div>
